import RfiReassignCategoriesModal from './RfiReassignCategoriesModal.component';

export default RfiReassignCategoriesModal;
